/**
 * @author Mustafa Omran <promustafaomran@hotmail.com>
 */
import * as $ from 'jquery';
import 'rxjs/add/operator/retry';
import { Component } from '@angular/core';
import { ActivatedRoute,Router } from '@angular/router';
import { TopStoresService } from '../../../services/Home/top-stores.service';
import { FormControl, FormGroup, FormBuilder, Validators, } from '@angular/forms';

@Component({
  selector: 'martmax-top-stores',
  templateUrl: './top-stores.component.html',
  styleUrls: ['./top-stores.component.css'],
  providers: [TopStoresService],
})
export class TopStoresComponent {

  config: SwiperOptions = {
    pagination: '.swiper-pagination',
    paginationClickable: true,
    slidesPerView: 4,
    spaceBetween: 30
  };

  public errors: any;
  public topStores: any;

  constructor(
    private router: Router,
    public topStoresService: TopStoresService,
  ) {
  }

  public ngOnInit() {
    this.topStoresService.getTopStores().subscribe(
      (data) => {
        this.topStores = data.topStores;
      },
      (errors) => {
        this.errors = errors;
      }
    );
  }

  /**
   * set store to local storage 
   * 
   * @param store 
   */
  public setStore(store) {
    localStorage.setItem('currentStore', JSON.stringify(store));
  }

}





// WEBPACK FOOTER //
// /opt/build/repo/src/app/MartMax/components/home-page/top-stores/top-stores.component.ts